// CSH 2.0 — locale-prefix link fixup.
//
// Some sections render hardcoded URLs from theme settings (e.g.
// templates/page.formations-index-csh.json's media-grid links to
// /pages/formation-XXX). These URLs are written without a locale
// prefix, so clicking them from /en/... drops the visitor onto the
// default-locale (FR) version of the destination page.
//
// This script runs on every page load and rewrites internal links
// missing the current locale prefix, before the user clicks them.
// Idempotent — safe to run on every page.
(function () {
  var pathname = window.location.pathname;
  var match = pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(\/|$)/i);
  if (!match) return;
  var prefix = '/' + match[1];
  var prefixSlash = prefix + '/';

  function fix(a) {
    var href = a.getAttribute('href');
    if (!href) return;
    if (href.charAt(0) !== '/') return;
    if (href === prefix || href.indexOf(prefixSlash) === 0) return;
    if (href.indexOf('/cdn/') === 0 || href.indexOf('/admin') === 0) return;
    // Skip locale-switcher links (they intentionally point at a
    // different locale's URL — adding the current locale prefix
    // breaks the switch).
    if (a.classList && a.classList.contains('csh-header__locale-btn')) return;
    var hreflang = a.getAttribute('hreflang');
    if (hreflang) {
      var current = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      if (hreflang.toLowerCase() !== current) return;
    }
    if (a.closest && a.closest('.csh-header__locale')) return;
    a.setAttribute('href', prefix + href);
  }

  function run() {
    var anchors = document.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) fix(anchors[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // Re-run after AJAX or section reloads (covers dynamic content).
  document.addEventListener('shopify:section:load', run);
})();
